'use strict'

require('../../../../node_modules/waypoints/lib/noframework.waypoints.min.js');

String.prototype.nthIndexOf = function (needle, index = 0) {
  return this.split(needle, index).join(needle).length
}

if (typeof window.CustomEvent !== 'function') {
  function CustomEvent (event, params) {
    params = params || { bubbles: false, cancelable: false, detail: null }
    var evt = document.createEvent('CustomEvent')
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail)
    return evt
  }

  window.CustomEvent = CustomEvent
}

if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector ||
                              Element.prototype.webkitMatchesSelector
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    var el = this

    do {
      if (el.matches(s)) return el
      el = el.parentElement || el.parentNode
    } while (el !== null && el.nodeType === 1)
    return null
  }
}

// if (![null, undefined, false, ''].includes(this.SliderItem.Slider)) {

export class Animator {
  constructor (publicObject, classPrefix = 'animator') {
    this.object = publicObject
    this.debug = false
    this.classPrefix = classPrefix

    this.log('Animator:constructor')

    this._h = this.helpers()

    this._getClass = this._h.getClass

    this.settings = {
      class: {
        initAnimate: this._h.class('-init'),
        beforeAnimate: this._h.class('-before'),
        animate: this._h.class('-on'),
        afterAnimate: this._h.class('-after')
      },
      transition: {
        normal: {
          duration: 300,
          delay: 0
        }
      }
    }
    // Prepare Body Vars
    this.prepareBodyVars()

    // Custom Events
    this.customEvents = {
      'a:onLoad': new CustomEvent('a:onLoad')
    }

    this.animatedItems = []

    document.addEventListener('readystatechange', (event) => {
      this.log('window:readystatechange', document.readyState, event)
    })
  }
  prepareBodyVars () {
    let dataColorVars = document.querySelector('[data-bodyVars-color]')
    if (dataColorVars) document.body.setAttribute('data-color-vars', dataColorVars.getAttribute('data-bodyVars-color'))
  }
  isDebug (value) {
    return this.debug === value
  }
  log (...logs) {
    if (this.isDebug(false)) return true
    console.log(...logs)
    return true
  }
  helpers () {
    return {
      class: (name) => {
        return this.classPrefix + name
      },
      getClass: (name) => {
        return this.settings.class[name]
      }
    }
  }
  getLoadEventEnd () {
    return window.performance.getEntriesByType('navigation')[0].loadEventEnd
  }
  setAnimated (type = 'ASAP', selector, config) {
    if (!selector && typeof selector !== 'object' && document.querySelector(selector) === null) return false
    Array.from(document.querySelectorAll(selector)).forEach((item, index) => {
      this.animatedItems.push({
        type: type,
        item: item,
        object: new (eval('Animated' + type))(item, this, config)
      })
    })
  }
  addEvent (...args) {
    return this.object.addEventListener(...args)
  }
  removeEvent (event) {
    return this.object.removeEventListener(event.type, event)
  }
}

class Animated {
  constructor (element, animator, settings = {}) {
    this.Animator = animator || window.Animator || null
    this._a = () => {
      return this.Animator
    }
    this.debug = true
    if (this.Animator === null) return false

    this._a().log('Animated:constructor')

    this.element = element
    this.active = true
    this.runningAnimations = 0
    this._getClass = this._a()._getClass

    this.settings = {
      propagation: false,
      direction: 'down',
      delayBefore: 0,
      delayAfter: 0,
      transitionExplicit: false,
      startOnExecution: false
    }

    Object.assign(this.settings, settings)
    // Custom Events
    this.customEvents = {
      'a:onCreate': new CustomEvent('a:onCreate'),
      'a:onFired': new CustomEvent('a:onFired'),
      'a:onStart': new CustomEvent('a:onStart'),
      'a:onEnd': new CustomEvent('a:onEnd'),
      'a:afterAnimate': new CustomEvent('a:afterAnimate')
    }

    this.addEvent('a:onCreate', (event) => {
      if (!this.canFire()) return false
      this.setPropagation(event)

      this._a().log('a:onCreate', event)

      this.element.classList.add(this._getClass('initAnimate'))

      this.addEvent('transitionstart', (event) => {
        this.element.dispatchEvent(this.customEvents['a:onFired'])
      })
      this.addEvent('transitionend', (event) => {
        this._a().log('Event:transitionend')
        this.element.dispatchEvent(this.customEvents['a:onEnd'])
      })
    })
    this.addEvent('a:onFired', (event) => {
      if (!this.canFire()) return false
      this.setPropagation(event)

      this._a().log('a:onFired', event)

      this.runningAnimations++
    })
    this.addEvent('a:onStart', (event) => {
      if (!this.canFire()) return false
      this.setPropagation(event)
      this._a().log('a:onStart', event)
      this.element.classList.add(this._getClass('beforeAnimate'))

      setTimeout(() => {
        this.element.classList.add(this._getClass('animate'))
      }, this.settings.delayBefore)
    })

    this.addEvent('a:onEnd', (event) => {
      if (!this.canFire()) return false
      this.setPropagation(event)

      this._a().log('a:onEnd / any', event)

      this.runningAnimations--
      if (this.runningAnimations === 0) {
        if (this.settings.transitionExplicit && !this.isTransitionExplicit(event)) return false

        this._a().log('a:onEnd / last', event)
        setTimeout(() => {
          if (this.element.classList.contains(this.Animator._getClass('animate'))) {
            this.setState('after')
          }
        }, this.settings.delayAfter)
      }
    })
  }
  canFire () {
    return !!this.active
  }
  setPropagation (event) {
    return !this.settings.propagation && undefined !== event ? event.stopPropagation() : false
  }
  isTransitionExplicit (event) {
    return !((event.path !== undefined && event.path[0] !== this.element))
  }
  onloadPossible () {
    return [undefined, null, 'loading', 'interactive'].indexOf(document.readyState) !== -1
  }
  addEvent (...args) {
    return this.element.addEventListener(...args)
  }
  removeEvent (event) {
    return this.element.removeEventListener(event.type, event)
  }
  setState (state) {
    if (state === 'after') {
      this.element.classList.add(this.Animator._getClass('afterAnimate'))
      this.element.dispatchEvent(this.customEvents['a:afterAnimate'])
    }
  }
}
class AnimatedASAP extends Animated {
  constructor (element, animator, config) {
    super(element, animator, config)

    this.element.dispatchEvent(this.customEvents['a:onCreate'])

    if (!this.settings.startOnExecution && this.onloadPossible()) {
      this.Animator.object.addEventListener('a:onLoad', (event) => {
        this.setPropagation(event)
        setTimeout(() => {
          this.element.dispatchEvent(this.customEvents['a:onStart'])
        }, this.settings.delayBefore)
      }, { once: true })
    } else {
      setTimeout(() => {
        this.element.dispatchEvent(this.customEvents['a:onStart'])
      }, this.settings.delayBefore)
    }
  }
}
class AnimatedWaypoint extends Animated {
  constructor (element, animator, config) {
    super(element, animator, config)
  
    this.element.dispatchEvent(this.customEvents['a:onCreate'])

    if (!this.offset) this.offset = '75%'
    
    if (!this.settings.startOnExecution && this.onloadPossible()) {
      this.Animator.object.addEventListener('a:onLoad', (event) => {
        this.setPropagation(event)
        setTimeout(() => {
          this.setWaypoint()
        }, this.settings.delayBefore)
      }, { once: true })
    } else {
      setTimeout(() => {
        this.setWaypoint()
      }, this.settings.delayBefore)
    }
  }
  setWaypoint () {
    let AnimatedWaypoint = this
    this.waypoint = new Waypoint({
      element: this.element,
      handler: function (direction) {
        if (direction === 'up' && AnimatedWaypoint.settings.direction !== 'down') {
          AnimatedWaypoint.element.classList.remove(AnimatedWaypoint._getClass('animate'))
          AnimatedWaypoint.element.classList.remove(AnimatedWaypoint._getClass('afterAnimate'))
        } else {
          AnimatedWaypoint.element.dispatchEvent(AnimatedWaypoint.customEvents['a:onStart'])
          if (AnimatedWaypoint.settings.direction === 'down') this.disable()
        }
      },
      offset: AnimatedWaypoint.offset
    })
  }
}

export default Animator

// once element.removeEventListener(event, arguments.callee);
